import * as types from "../constants/grievance_constants";

const initialState = {
  grievances: [],
  currentGrievance: null,
  grievanceError: null,
  message: null,
};

const grievanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_ADMIN_GRIEVANCES_SUCCESS:
      return {
        ...state,
        grievances: payload?.grievances || [],
        grievanceError: null,
      };

    case types.GET_SINGLE_ADMIN_GRIEVANCE_SUCCESS:
      return {
        ...state,
        currentGrievance: payload?.grievance || null,
        grievanceError: null,
      };

    case types.UPDATE_ADMIN_GRIEVANCE_SUCCESS:
      return {
        ...state,
        currentGrievance: payload?.grievance || state.currentGrievance,
        message: payload ? "Grievance updated successfully" : null,
        grievanceError: null,
      };

    case types.GET_ADMIN_GRIEVANCES_FAILURE:
    case types.GET_SINGLE_ADMIN_GRIEVANCE_FAILURE:
    case types.UPDATE_ADMIN_GRIEVANCE_FAILURE:
      return {
        ...state,
        grievanceError: payload || null,
      };

    default:
      return state;
  }
};

export default grievanceReducer;
